export default {
  "brand.name": "AllChinaBuy Spreadsheet",
  "brand.tagline": "Produktrecherche, organisiert",

  "nav.home": "Start",
  "nav.buyingGuide": "Kaufguide",
  "nav.guide": "Spreadsheet-Leitfaden",
  "nav.categories": "Kategorien",
  "nav.faq": "FAQ",

  "buttons.allchinabuySpreadsheet": "AllChinaBuy Spreadsheet",
  "buttons.buyItNow": "Jetzt kaufen",
  "buttons.viewCategory": "Kategorie ansehen",
  "buttons.browse": "Alle ansehen",

  "categories.shoes": "Schuhe",
  "categories.hoodies": "Hoodies / Sweatshirts",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jacken",
  "categories.pants": "Hosen / Shorts",
  "categories.headwear": "Kopfbedeckung",
  "categories.sets": "Sets",
  "categories.underwear": "Unterwäsche",
  "categories.jersey": "Trikots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Taschen",
  "categories.belts": "Gürtel",
  "categories.perfumes": "Parfums",
  "categories.other": "Sonstiges",

  "languages.en": "English",
  "languages.fr": "Français",
  "languages.da": "Dansk",
  "languages.de": "Deutsch",

  "footer.disclaimer": "Unabhängige Ressource · Nicht die offizielle AllChinaBuy-Website",
  "footer.rights": "Alle Rechte vorbehalten.",
  "footer.explore": "Entdecken",
  "footer.resources": "Ressourcen",
  "footer.backHome": "Zurück zur Startseite",
  "footer.browseCategories": "Kategorien durchstöbern",
};